var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.91,850.8h725.44v48.36H63.91v-48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M789.35,866.92h161.21v80.6h-161.21v-80.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M934.44,294.63c-25.78,0-46.75-18.08-46.75-40.3s20.97-40.3,46.75-40.3,46.75,18.08,46.75,40.3-20.97,40.3-46.75,40.3ZM934.44,230.15c-16.89,0-30.63,10.85-30.63,24.18s13.74,24.18,30.63,24.18,30.63-10.85,30.63-24.18-13.74-24.18-30.63-24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.91,480.02h693.19v370.78H63.91v-370.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M861.89,866.92c45.84,0,84.12,34.95,88.28,80.6h48.74v-177.33l-48.36-128.97h-128.97v225.69h40.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.91,899.16h435.26v48.36H63.91v-48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M966.68,899.16h48.36v48.36h-48.36v-48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M853.83,576.74h-64.48v290.17h32.24v-259.63h32.24v-30.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M789.35,665.41h32.24v16.12h-32.24v-16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M869.95,673.47h64.48v96.72h-64.48v-96.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M962.65,673.47l36.27,96.72h-64.48v-96.72h28.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M910.26,810.5h-32.24c-4.45,0-8.06-3.61-8.06-8.06s3.61-8.06,8.06-8.06h32.24c4.45,0,8.06,3.61,8.06,8.06s-3.61,8.06-8.06,8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.42,899.16h209.57v48.36h-209.57v-48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M668.44,899.16h16.12v48.36h-16.12v-48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M700.69,899.16h16.12v48.36h-16.12v-48.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.28,850.8h32.24v48.36h-32.24v-48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M547.54,850.8h32.24v48.36h-32.24v-48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.45,850.8h32.24v48.36h-32.24v-48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M692.63,850.8h32.24v48.36h-32.24v-48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.36,850.8h32.24v48.36h-32.24v-48.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.91,480.02h693.19v32.24H63.91v-32.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 531.3,
    cy: 431.66,
    r: 8.06,
    transform: "translate(20.11 886.95) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M508.5,416.92c-4.45,0-8.06-3.61-8.06-8.06,0-2.14.85-4.19,2.36-5.7,15.74-15.74,41.26-15.74,57,0,3.15,3.15,3.15,8.25,0,11.4-3.15,3.15-8.25,3.15-11.4,0-9.44-9.44-24.75-9.45-34.2,0h0c-1.51,1.52-3.56,2.37-5.7,2.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M576.89,394.12c-2.14,0-4.19-.85-5.7-2.36-22.03-22.04-57.76-22.04-79.79,0h0c-3.15,3.15-8.25,3.15-11.4,0s-3.15-8.25,0-11.4c28.33-28.33,74.26-28.33,102.59,0,3.15,3.15,3.15,8.25,0,11.4-1.51,1.51-3.56,2.36-5.7,2.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M462.9,371.32c-4.45,0-8.06-3.61-8.06-8.06,0-2.14.85-4.19,2.36-5.7,40.92-40.92,107.27-40.92,148.19,0,3.2,3.09,3.29,8.2.2,11.4-3.09,3.2-8.2,3.29-11.4.2-.07-.06-.13-.13-.2-.2-34.63-34.63-90.76-34.63-125.39,0h0c-1.51,1.52-3.56,2.37-5.7,2.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.4,286.57c-22.22,0-40.3-15.67-40.3-34.93s18.08-34.93,40.3-34.93,40.3,15.67,40.3,34.93-18.08,34.93-40.3,34.93ZM128.4,232.83c-13.33,0-24.18,8.44-24.18,18.81s10.85,18.81,24.18,18.81,24.18-8.44,24.18-18.81-10.85-18.81-24.18-18.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M886.08,125.36c0,26.71,48.36,128.97,48.36,128.97,0,0,48.36-102.26,48.36-128.97s-21.65-48.36-48.36-48.36-48.36,21.65-48.36,48.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M934.44,149.54c-13.35,0-24.18-10.83-24.18-24.18s10.83-24.18,24.18-24.18,24.18,10.83,24.18,24.18c-.01,13.35-10.83,24.17-24.18,24.18ZM934.44,117.3c-4.45,0-8.06,3.61-8.06,8.06s3.61,8.06,8.06,8.06,8.06-3.61,8.06-8.06-3.61-8.06-8.06-8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.84,429.42c-25.21,0-49.75-8.16-69.92-23.28l-4.66-3.5c-26.32-19.84-41.84-50.86-41.91-83.83,0-4.45,3.61-8.06,8.06-8.06s8.06,3.61,8.06,8.06c.06,27.89,13.19,54.14,35.47,70.93l4.67,3.5c44.28,33.21,107.1,24.24,140.31-20.04,1.54-2.05,3-4.16,4.37-6.32l10.21-16.05c64.7-101.68,197.86-134.61,302.5-74.81l154.46,88.26c39.88,22.79,90.68,8.93,113.47-30.95.76-1.33,1.49-2.69,2.18-4.06l7.03-14.06c1.92-4.01,6.74-5.71,10.75-3.79,4.01,1.92,5.71,6.74,3.79,10.75-.04.08-.08.16-.12.24l-7.03,14.06c-24.52,49.04-84.16,68.92-133.2,44.4-1.64-.82-3.26-1.69-4.86-2.6l-154.46-88.26c-97.17-55.52-220.81-24.94-280.89,69.47l-10.21,16.05c-21.3,33.56-58.3,53.89-98.05,53.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M708.75,375.23c-22.22,0-40.3-14.46-40.3-32.24s18.08-32.24,40.3-32.24,40.3,14.46,40.3,32.24-18.08,32.24-40.3,32.24ZM708.75,326.87c-13.1,0-24.18,7.38-24.18,16.12s11.08,16.12,24.18,16.12,24.18-7.38,24.18-16.12-11.07-16.12-24.18-16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M676.5,255.57c0,18.49,33.48,89.29,33.48,89.29,0,0,33.48-70.79,33.48-89.28-.14-18.49-15.25-33.36-33.74-33.22-18.29.14-33.08,14.93-33.22,33.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 711.14,
    cy: 254.37,
    r: 10.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.34,415.54c-25.78,0-46.75-18.08-46.75-40.3s20.97-40.3,46.75-40.3,46.75,18.08,46.75,40.3-20.97,40.3-46.75,40.3ZM307.34,351.05c-16.89,0-30.63,10.85-30.63,24.18s13.74,24.18,30.63,24.18,30.63-10.85,30.63-24.18-13.74-24.18-30.63-24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.36,254.33c0,26.71,48.36,128.97,48.36,128.97,0,0,48.36-102.26,48.36-128.97s-21.65-48.36-48.36-48.36-48.36,21.65-48.36,48.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 305.73,
    cy: 254.33,
    r: 16.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.16,173.72c0,17.81,32.24,85.98,32.24,85.98,0,0,32.24-68.17,32.24-85.98s-14.44-32.24-32.24-32.24-32.24,14.44-32.24,32.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 128.4,
    cy: 173.72,
    r: 10.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 200.94,
    cy: 955.58,
    r: 56.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 346.03,
    cy: 955.58,
    r: 56.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 861.89,
    cy: 955.58,
    r: 56.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 861.89,
    cy: 955.58,
    r: 16.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 346.03,
    cy: 955.58,
    r: 16.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 200.94,
    cy: 955.58,
    r: 16.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.9a28f36463ac038838366f555301b6d9.svg";
export { ForwardRef as ReactComponent };